import { render, staticRenderFns } from "./goodsCustomized.vue?vue&type=template&id=179db272&scoped=true"
import script from "./goodsCustomized.vue?vue&type=script&lang=js"
export * from "./goodsCustomized.vue?vue&type=script&lang=js"
import style0 from "./goodsCustomized.vue?vue&type=style&index=0&id=179db272&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179db272",
  null
  
)

export default component.exports